module.exports = __webpack_public_path__ + "img/training.8c54743d.png";